import { makeStyles } from '@material-ui/core/styles';
import { EVENT_TYPE } from '../../../../constants/index';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    '& .fallback-img img': {
      height: '100%',
    },
    '& .main-heading': {
      '& h2': {
        ...theme.palette.common.ellipsis(2),
      },
    },
    '& .slick-arrow': {
      [theme.breakpoints.down('md')]: {
        display: 'none !important',
      },
    },
    '& .MuiButton-endIcon': {
      backgroundColor: ({ pageContentType }) =>
        pageContentType === EVENT_TYPE && theme.mixins.DarkTurquoise(),
    },
    '& .MuiButton-root:hover .MuiButton-endIcon': {
      backgroundColor: ({ pageContentType }) =>
        pageContentType === EVENT_TYPE && theme.mixins.DarkTurquoise(500),
    },
    '& .btnWithBorder': {
      borderWidth: 0,
    },

    '&.ADrelatedEvents': {
      overflow: 'hidden',
      '& .titleContainer': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: pxToRem(48),

        [theme.breakpoints.down('md')]: {
          marginBottom: pxToRem(32),
        },

        '& .btnWithBorder': {
          padding: 0,
        },
      },

      '& .main-heading': {
        display: 'flex',
        marginBottom: 0,
        '& h2': {
          fontFamily: theme.custom.fontFamily.primaryBold,
          fontWeight: '400',
          color: '#FFF',
        },
        '@media (max-width: 768px)': {
          fontSize: pxToRem(26),
          lineHeight: pxToRem(32),
        },

        '@media (max-width: 375px)': {
          fontSize: pxToRem(22),
        },
      },

      '& .btnWithBorder': {
        color: '#FFF',
        '& .btn-txt': {
          fontFamily: theme.custom.fontFamily.primaryBold,
          fontWeight: '400',
          fontSize: pxToRem(22),
        },

        '& .MuiButton-endIcon': {
          ...theme.mixins.marginLeft(pxToRem(22)),
          backgroundColor: theme.mixins.AbuDhabiOrange(),
        },

        [theme.breakpoints.down('md')]: {
          marginTop: pxToRem(15),

          '& .btn-txt': {
            fontSize: pxToRem(16),
          },

          '& .MuiButton-endIcon': {
            ...theme.mixins.marginLeft(pxToRem(16)),
          },
        },
      },

      '& .slick-slider': {
        overflow: 'visible',
        [theme.breakpoints.down('md')]: {
          ...theme.mixins.paddingRight(0),
        },
        '& .slick-arrow': {
          '& .MuiButtonBase-root': {
            borderColor: '#fff',
            backgroundColor: '#fff',
            boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
            width: pxToRem(56),
            height: pxToRem(56),
          },
          '&:hover': {
            '& .MuiButtonBase-root': {
              backgroundColor: '#4C0C47',
              borderColor: '#4C0C47',
              '@media (max-width: 1280px)': {
                backgroundColor: '#ffffff',
                borderColor: '#ffffff',
              },
              [theme.breakpoints.down('md')]: {
                backgroundColor: '#ffffff',
                borderColor: '#ffffff',
              },
              '& svg': {
                '& path': {
                  color: '#fff',
                  '@media (max-width: 1280px)': {
                    color: '#000',
                  },
                }
              }
            }
          },
          '&.slick-disabled': {
            opacity: 0
          }
        },
        '& .slick-prev': {
          left: `calc(7% - ${pxToRem(64)})`
        },
        '& .slick-next': {
          right: `calc(7% - ${pxToRem(64)})`
        },
        '& .slick-list': {
          overflow: 'visible',
          [theme.breakpoints.down('md')]: {
            overflow: 'auto',
          },
          '& .slick-track': {
            overflow: 'visible',

            [theme.breakpoints.up('lg')]: {
              paddingBottom: 0,
            },

            [theme.breakpoints.down('md')]: {
              paddingBottom: pxToRem(9),
              left: '0 !important',
            },

            '& .slick-slide': {
              zIndex: '1',
              borderRadius: pxToRem(10),
              ...theme.mixins.marginRight(12),
              '& .heartIcon': {
                '& svg': {
                  width: pxToRem(24),
                  height: pxToRem(24),
                }
              },
              '& .imageWrap': {
                height: pxToRem(224)
              },
              '& .calenderType': {
                padding: `${pxToRem(24)} ${pxToRem(16)}`,

                [theme.breakpoints.down('md')]: {
                  display: 'flex',
                  flexDirection: 'column',
                },

                '& .eventName': {
                  color: "#000000",
                  [theme.breakpoints.down('md')]: {
                    fontFamily: theme.custom.fontFamily.primaryBold,
                    fontSize: pxToRem(12),
                    lineHeight: pxToRem(16),
                  }
                },
                '& .eventTitle': {
                  [theme.breakpoints.down('md')]: {
                    fontFamily: theme.custom.fontFamily.primaryRegular,
                    lineHeight: pxToRem(32),
                  },
                },
                '& .eventLocation': {
                  color: "#706C6C",

                  [theme.breakpoints.down('md')]: {
                    marginTop: 'auto',
                    fontFamily: theme.custom.fontFamily.primaryRegular,
                    lineHeight: pxToRem(18),
                    fontSize: pxToRem(12),
                  },
                }
              }
            }
          }
        },
      },
    },
  },
  rtlClass: {
    '&  [dir="ltr"] .slick-prev::before,& [dir="ltr"] .slick-next::before': {
      content: "''",
    },
    '&  [dir="ltr"] .slick-prev': {
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.right('5.5%'),
        ...theme.mixins.left('auto'),
      },
    },
    '&  [dir="ltr"] .slick-next': {
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.right('12.5%'),
      },
    },
    '& .slick-slider': {
      [theme.breakpoints.down('md')]: {
        direction: 'rtl',
      },
    },
    '& .slick-slider .slick-track': {
      [theme.breakpoints.down('md')]: {
        flexDirection: 'row-reverse',
      },
    },
    '& .slick-slider .MuiChip-root': {
      whiteSpace: 'unset',
      height: 'auto',
    },
    '& .slick-slider .MuiChip-root .MuiChip-label': {
      whiteSpace: 'unset',
    },
  },
  fallback: {
    '& .fallback-img': {
      paddingTop: '66.67%',
      background: '#ccc',
      '& img': {
        height: '0',
      },
    },
  },
}));

export default useStyles;
